// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"855973ab","499":"408c3ff0"}[chunkId] + ".chunk.css";
};